<template>
  <v-dialog max-width="500" v-model="dialog.shows.showDetail">
    <v-card>
      <v-card-title>
        <div class="title">{{ $vuetify.lang.t(dialog.title) }}</div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-list two-line>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-cash</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{
                form.oldAmount
              }}</v-list-item-title>
              <v-list-item-subtitle
                >{{
                  $vuetify.lang.t("$vuetify.provision.cols.oldAmount.title")
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-cash</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{
                form.amount
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                $vuetify.lang.t("$vuetify.provision.cols.amount.title")
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-cash</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">
                <v-chip
                  :color="form.newAmount > 0 ? 'teal accent-4' : 'red'"
                  class="chip-list"
                  text-color="white"
                  >{{ form.newAmount }}
                </v-chip>
              </v-list-item-title>
              <v-list-item-subtitle
                >{{
                  $vuetify.lang.t("$vuetify.provision.cols.newAmount.title")
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-apps</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{
                form.type
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                $vuetify.lang.t("$vuetify.provision.cols.type.title")
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-bank</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{
                form.reference
              }}</v-list-item-title>
              <v-list-item-subtitle
                >{{
                  $vuetify.lang.t("$vuetify.provision.cols.reference.title")
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-transfer</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">
                <v-chip
                  :color="form.operation === 'CREDIT' ? 'cyan' : 'red'"
                  class="chip-list"
                  text-color="white"
                >
                  {{
                    form.operation
                      ? $vuetify.lang.t("$vuetify.operations." + form.operation)
                      : "-"
                  }}
                </v-chip>
              </v-list-item-title>
              <v-list-item-subtitle
                >{{
                  $vuetify.lang.t("$vuetify.provision.cols.operation.title")
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <template v-if="form.rollbacked">
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="secondary">mdi-backup-restore</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="body-1">
                  <v-chip
                    color="teal accent-4"
                    class="chip-list"
                    text-color="white"
                  >
                    {{ $vuetify.lang.t("$vuetify.operations.CANCEL") }}
                  </v-chip>
                </v-list-item-title>
                <v-list-item-subtitle
                  >{{ $vuetify.lang.t("$vuetify.provision.cols.charge.title") }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-scale-balance</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">
                <v-chip
                  color="teal accent-4"
                  class="chip-list"
                  text-color="white"
                >
                  {{ form.charges }}
                </v-chip>
              </v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.provision.cols.charge.title") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <template v-if="!$auth.check(['ROLE_CLIENT'])">
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="secondary">mdi-account-multiple-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="body-1">
                  <v-chip
                    class="chip-list"
                    color="primary"
                    text-color="white"
                    >{{ form.username }}</v-chip
                  >
                </v-list-item-title>
                <v-list-item-subtitle>{{
                  $vuetify.lang.t("$vuetify.provision.cols.user.title")
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-calendar</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{
                form.createdAt
              }}</v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.provision.cols.created.title") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-note-text</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{
                form.comment
              }}</v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.provision.cols.comment.title") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog.shows.showDetail = false" text>{{
          $vuetify.lang.t("$vuetify.btn.close")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    dialog: {
      type: Object,
      default: function() {
        return {
          title: "$vuetify.provision.view.title",
          shows: {
            showDetail: false
          },
          saveBtnTitle: "$vuetify.btn.save",
          action: "detail"
        };
      }
    },
    form: {
      type: Object,
      default: function() {
        return {
          amount: null,
          operation: null,
          comment: null
        };
      }
    }
  },
  data: () => ({
    itemsOperations: []
  }),
  created() {
    this.setItemOperations();
  },
  methods: {
    setItemOperations() {
      let self = this;
      this.operations.forEach(r => {
        self.itemsOperations.push({
          text: self.$vuetify.lang.t("$vuetify.operations." + r),
          value: r
        });
      });
    },
    setForm(item) {
      this.form["user"] = item.id;
      if (!this.$auth.check(["ROLE_CLIENT"]))
        this.form["username"] = item.user.profile.fullName;
      this.form["oldAmount"] = item.oldAmount;
      this.form["newAmount"] = item.newAmount;
      this.form["type"] = item.type;
      this.form["operation"] = item.operation;
      this.form["amount"] = item.amount;
      this.form["rollbacked"] = item.rollbacked;
      this.form["charges"] = item.charges;
      this.form["reference"] = item.reference ? item.reference : " - ";
      this.form["comment"] = item.comment ? item.comment : " - ";
      this.form["createdAt"] = this.$moment(item.createdAt).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    }
  },
  computed: {
    ...mapGetters({ operations: "user/operations" })
  }
};
</script>

<style scoped>
>>> .v-list-item__title {
  white-space: initial;
}
</style>
